export default {
    cn: {
        mt4EquityMultiReport: {
            timeText: '日期：',
            dateText: '请选择日期',
            downloadName: 'MT4净值报表',
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'TIME', value: '时间' },
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'OID', value: '办事处号码' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'RID', value: '地区编号' },
                { key: 'GROUP', value: '组别' },
                { key: 'CLOSED_PL', value: '平仓盈亏' },
                { key: 'DEPOSIT', value: '存取款金额' },
                { key: 'BALANCE', value: '今日余额' },
                { key: 'FLOATING_PL', value: '浮动盈亏' },
                { key: 'CREDIT', value: '信用额' },
                { key: 'EQUITY', value: '净值' },
                { key: 'USED_MARGIN', value: '保证金' },
                { key: 'MARGIN_FREE', value: '可用保证金' },
                { key: 'BANK', value: '注释' },
            ]
        }
    },
    hk: {
        mt4EquityMultiReport: {
            timeText: '日期：',
            dateText: '請選擇日期',
            downloadName: 'MT4淨值報表',
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'TIME', value: '時間' },
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'RID', value: '地區編號' },
                { key: 'GROUP', value: '組別' },
                { key: 'CLOSED_PL', value: '平倉盈虧' },
                { key: 'DEPOSIT', value: '存取款金額' },
                { key: 'BALANCE', value: '今日餘額' },
                { key: 'FLOATING_PL', value: '浮動盈虧' },
                { key: 'CREDIT', value: '信用額' },
                { key: 'EQUITY', value: '淨值' },
                { key: 'USED_MARGIN', value: '保證金' },
                { key: 'MARGIN_FREE', value: '可用保證金' },
                { key: 'BANK', value: '注釋' },
            ]
        }
    },
    en: {
        mt4EquityMultiReport: {
            timeText: 'Date：',
            dateText: 'Please Select Date',
            downloadName: 'MT4 Equity Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'TIME', value: 'Time' },
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'GROUP', value: 'Group' },
                { key: 'CLOSED_PL', value: 'Closed PL' },
                { key: 'DEPOSIT', value: 'Deposit' },
                { key: 'BALANCE', value: 'Balance' },
                { key: 'FLOATING_PL', value: 'Floating PL' },
                { key: 'CREDIT', value: 'Credit' },
                { key: 'EQUITY', value: 'Equity' },
                { key: 'USED_MARGIN', value: 'Margin' },
                { key: 'MARGIN_FREE', value: 'Free Margin' },
                { key: 'BANK', value: 'Bank' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/mt4EquityMultiReport.js